const FilterLinesIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.75 4.5H2.25V6H15.75V4.5ZM13.5 8.25H4.5V9.75H13.5V8.25ZM7.5 12H10.5V13.5H7.5V12Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default FilterLinesIcon;
